import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CharacterSheetEquipment from '@/pages/Tools/MyCharacters/CharacterSheet/CharacterSheetEquipment.vue';
import generateEquipment from '@/modules/CharacterEngine/generateEquipment';
import generateAttunement from '@/modules/CharacterEngine/generateAttunement';
import applyTweak from '@/utilities/applyTweak';
const equipmentModule = namespace('equipment');
const enhancedItemsModule = namespace('enhancedItems');
let CharacterBuilderEquipment = class CharacterBuilderEquipment extends Vue {
    get myEquipment() {
        return generateEquipment(this.rawCharacter, this.equipment, this.enhancedItems);
    }
    get myAttunement() {
        const currentLevel = this.rawCharacter.classes.reduce((acc, { levels }) => acc + levels, 0);
        const proficiencyBonus = applyTweak(this.rawCharacter, 'proficiencyBonus', 1 + Math.ceil(currentLevel / 4));
        return generateAttunement(this.myEquipment, proficiencyBonus);
    }
};
__decorate([
    Prop(Object)
], CharacterBuilderEquipment.prototype, "rawCharacter", void 0);
__decorate([
    equipmentModule.State
], CharacterBuilderEquipment.prototype, "equipment", void 0);
__decorate([
    enhancedItemsModule.State
], CharacterBuilderEquipment.prototype, "enhancedItems", void 0);
CharacterBuilderEquipment = __decorate([
    Component({
        components: {
            CharacterSheetEquipment
        }
    })
], CharacterBuilderEquipment);
export default CharacterBuilderEquipment;
